import { ServiceName } from '@99designs/graph-utils/types';
import { useSelectProductWithCacheUpdate } from '../ClientConfiguredFields/ProductDropdown/useSelectProductMutation';
import { useUpdateField } from '../useUpdateField';
import { useBriefSetGridChoiceMutation } from './briefSetGridChoice.generated';

export function useUpdateGridChoiceField(
    key: string,
    briefId?: string,
    initialValue?: string | null
) {
    const { selectProduct } = useSelectProductWithCacheUpdate();

    const [setGridChoice] = useBriefSetGridChoiceMutation({
        onCompleted: (briefData) => {
            if (key !== 'requestType') {
                return;
            }
            const field = briefData.setField.dynamicFields.find((field) => field.id === key);
            if (!field) {
                return;
            }
            if (field.__typename !== 'GridChoiceField') {
                throw new Error(
                    "Field is not a GridChoiceField. This schema is not compatible with the fields currently in use on the front end. And will cause all kinds of trouble. If you're seeing this error in bugsnag, investigate immediately"
                );
            }
            const serviceMpvId = serviceNameToMpvId(field.choiceValue);
            if (briefData.setField.correlationId && serviceMpvId) {
                selectProduct({
                    variables: {
                        requestId: briefData.setField.correlationId,
                        input: {
                            serviceProductMpvId: serviceMpvId,
                            printProductMpvId: [], // this does not unset the physical product.
                        },
                    },
                });
            }
        },
    });
    return useUpdateField<string>({ key, setField: setGridChoice, briefId, initialValue });
}

function serviceNameToMpvId(serviceName: string | null): string | null {
    switch (serviceName) {
        case 'DesignLive':
            return 'designlive';
        case 'Standard':
            return 'caredesign';
        default:
            return null;
    }
}
